export enum MoveSiteToHouseholderErrorCode {
  INVALID_SEGMENT = "INVALID_SEGMENT",
  SITE_HAS_PLANNED_APPOINTMENT = "SITE_HAS_PLANNED_APPOINTMENT",
  SITE_HAS_NO_SUBSCRIBER = "SITE_HAS_NO_SUBSCRIBER",
  SITE_HAS_NO_LAYOUT = "SITE_HAS_NO_LAYOUT",
  PROFESSIONAL_LAYOUT_WITHOUT_SMALL_COMPANY = "PROFESSIONAL_LAYOUT_WITHOUT_SMALL_COMPANY",
}
